import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { FlinkCoAdminStoreEffects } from './effects';
import { FlinkCoAdminReducer } from './reducer';

@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature('flinkco-admin', FlinkCoAdminReducer),
		EffectsModule.forFeature([FlinkCoAdminStoreEffects]),
	],
	providers: [FlinkCoAdminStoreEffects],
})
export class FlinkCoAdminStoreModule {}
